// @flow
import JQueryView, { on } from '../../common/JQueryView';
import { carrierMail } from '../../../models/users/User';

declare var $: any;

export default class FormView extends JQueryView {
  investor: boolean;

  constructor(investor: boolean) {
    super('.simple_form');
    this.investor = investor;
    this.render();
  }

  @on('change #display_password')
  onChangeDisplayPassword() {
    const displayPassword = $('#display_password')
      .filter(':checked')
      .val();
    $('#user_password').attr({
      type: displayPassword != null ? 'text' : 'password',
    });
  }

  @on('input #user_email')
  onInputUserEmail() {
    this.render();
  }

  render() {
    if (this.investor) {
      const text = $('#user_email').val();
      if (carrierMail(text)) {
        $('#user_email').addClass('carrier-email');
        $('#carrier_attention').show();
      } else {
        $('#user_email').removeClass('carrier-email');
        $('#carrier_attention').hide();
      }
    }
  }
}
